import { printPDF } from '~core/printPDF';

export const onPrintCanvasBtnClick = async (event) => {
  event.preventDefault();
  await printPDF();
};
